import { render } from "./EnWidgetCard.vue?vue&type=template&id=63a8a7e2&scoped=true"
import script from "./EnWidgetCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EnWidgetCard.vue?vue&type=script&setup=true&lang=js"

import "./EnWidgetCard.vue?vue&type=style&index=0&id=63a8a7e2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a8a7e2"],['__file',"Shared/components/widgets/EnWidgetCard/EnWidgetCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63a8a7e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63a8a7e2', __exports__)) {
    api.reload('63a8a7e2', __exports__)
  }
  
  module.hot.accept("./EnWidgetCard.vue?vue&type=template&id=63a8a7e2&scoped=true", () => {
    api.rerender('63a8a7e2', render)
  })

}


export default __exports__